import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { faCube, faEye, faPenRuler, faShareNodes, faSlider, faSliders, faGlobe } from '@fortawesome/pro-regular-svg-icons';

import { MainTabs } from '../../models/main-tabs.enum';
import { SurveyEditorService } from '../../services/survey-editor.service';

@Component({
  selector: 'empathy-main-tabs',
  templateUrl: 'main-tabs.component.html',
  styleUrls: ['./main-tabs.component.scss', './_main-tabs-theme.component.scss']
})
export class MainTabsComponent {
  @Input() activeTab: MainTabs;
  @Input() translationsOnly = false;

  @Output() tabChange = new EventEmitter<MainTabs>();

  surveyEditorService = inject(SurveyEditorService);

  faCube = faCube;
  faEye = faEye;
  faPenRuler = faPenRuler;
  faShareNodes = faShareNodes;
  faSlider = faSlider;
  faSliders = faSliders;
  faGlobe = faGlobe;

  mainTabs = MainTabs;
}
